import Button from "@mui/material/Button";
import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Tooltip } from "@mui/material";
import SuperAdminPermissionList from "./SuperAdminPermissionList";

function AssignPermissionsSuperAdminModal({ open, setOpen }: { open: boolean, setOpen: any }) {

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth={false}
            sx={{ "& .MuiDialog-paper": { width: "80vw", maxWidth: "80vw" } }}
        >
            <DialogTitle>
                Select Permissions
            </DialogTitle>
            <DialogContent className="">
                <SuperAdminPermissionList handleClose={handleClose} />
            </DialogContent>
        </Dialog>
    );
}


export const AssignPermissionsSuperAdmin = ({ path }: any) => {
    const [open, setOpen] = React.useState(false);
    return <>
        <AssignPermissionsSuperAdminModal open={open} setOpen={setOpen} />
        <Tooltip title="Assign Permissions">
            <Button sx={{ paddingBottom: "0" }} className="gap-3 pb-0" onClick={() => {
                setOpen(true)
            }}>
                Assign Permissions
            </Button>
        </Tooltip>
    </>
};

